export const useHeaderCollapseStore = defineStore({
  id: 'formCollapse',
  state: () => ({
    isHeaderCollapsed: false,
    isDateSliderCollapsed: false,
    isDateSliderSticky: false,
  }),
  actions: {
    updateHeaderState(value) {
      this.isHeaderCollapsed = value;
    },
    updateDateSliderState(value) {
      this.isDateSliderCollapsed = value;
    },
    updateDateSliderStickyState(value) {
      this.isDateSliderSticky = value;
    },
  },
});
